@if (!isText && name) {
  <i
    [ngClass]="iconClass"
    [attr.title]="altText | translate"
  [attr.style]="style"></i>
}
@if (!isText && overlayIconClass) {
  <i
  [ngClass]="overlayIconClass"></i>
}
@if (isText) {
  <div
  [innerHTML]="fallbackText"></div>
}
